const translations = {
  "en": {
    "Search": "Search"
  },
  "zh-tw": {
    "Search": "搜尋"
  }
};

export default translations;
